export default __webpack_public_path__ + "static/telefono-2e33689dfc81d8b73317b3dd67d81f56.svg";